import HomeIcon from '@mui/icons-material/Home';
import PsychologyIcon from '@mui/icons-material/Psychology';
import PhoneIcon from '@mui/icons-material/Phone';
import ForumIcon from '@mui/icons-material/Forum';
import ScienceIcon from '@mui/icons-material/Science';
import VoiceChatIcon from '@mui/icons-material/VoiceChat';
import WidgetsIcon from '@mui/icons-material/Widgets';
import IntegrationIcon from '@mui/icons-material/Extension';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import StorefrontIcon from '@mui/icons-material/Storefront';
// import PeopleIcon from '@mui/icons-material/People';
// import CampaignIcon from '@mui/icons-material/Campaign';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import DescriptionIcon from '@mui/icons-material/Description';
// import PublicIcon from '@mui/icons-material/Public';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import LanguageIcon from '@mui/icons-material/Language';

const menuItems = [
  { text: 'Dashboard', icon: <HomeIcon fontSize="small" />, path: '/dashboard' },
  { text: 'Agent', icon: <PsychologyIcon fontSize="small" />, path: '/agent' },
  // { text: 'Call Agent', icon: <PhoneIcon fontSize="small" />, path: '/call-agent' },
  { text: 'Widget', icon: <WidgetsIcon fontSize="small" />, path: '/widget' },
  { text: 'Conversations', icon: <ForumIcon fontSize="small" />, path: '/conversations' },
  { text: 'Voices', icon: <VoiceChatIcon fontSize="small" />, path: '/voices' },
  { text: 'Test Zone', icon: <ScienceIcon fontSize="small" />, path: '/test-zone' },
  { text: 'Integration', icon: <IntegrationIcon fontSize="small" />, path: '/integration' },
//   { text: 'Orders', icon: <ShoppingCartIcon fontSize="small" />, path: '/orders', badge: 17 },
//   { text: 'Products', icon: <StorefrontIcon fontSize="small" />, path: '/products' },
//   { text: 'Customers', icon: <PeopleIcon fontSize="small" />, path: '/customers' },
//   { text: 'Marketing', icon: <CampaignIcon fontSize="small" />, path: '/marketing' },
//   { text: 'Discounts', icon: <LocalOfferIcon fontSize="small" />, path: '/discounts' },
//   { text: 'Content', icon: <DescriptionIcon fontSize="small" />, path: '/content' },
//   { text: 'Markets', icon: <PublicIcon fontSize="small" />, path: '/markets' },
//   { text: 'Analytics', icon: <BarChartIcon fontSize="small" />, path: '/analytics' },
//   { section: 'Sales channels' },
//   { text: 'Online Store', icon: <LanguageIcon fontSize="small" />, path: '/online-store' },
//   { section: 'Apps' },
];

export default menuItems;
